import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/landing-digital/unlock.png";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Unlock(props) {
    return (
        <div className="unlock-consultant p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="unlock-cons-img">
                            <LazyLoadImage
                                src={Img}
                                effect="blur" alt="unlock" className="img-fluid"
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="unlock-cons-content">
                            <h2><span class="orange">Unlock Growth</span> Through Expert Digital Consulting Services</h2>
                            <p>At TekRevol, our mission spins around plotting the right course and nurturing unceasing progress. Our untiring confidence in the potential of the digital revolution has not only boosted us this far but also strengthen our trust in the evolving capabilities of technology. Our groundbreaking spirit propel us to offer an unmatched digital consulting service that serves as a channel for yielding the true power of digital solutions. As a renowned player among digital strategy consulting firms, we are devoted to navigating businesses toward maintainable growth in the digital landscape.</p>
                            <p>Drawing on a pool of knowledge and experience, we go beyond traditional consulting models to deliver rounded digital business consulting. Our personalized strategies are entrenched in in-depth market insights and leading-edge techniques, guaranteeing that every step you take is one toward success in the digital world.</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Unlock;